import {  Fragment } from "react";
import Logo from "../../../../assets/images/Logo.png"
import useMediaQuery from "@mui/material/useMediaQuery";
import { useHistory } from "react-router-dom";
import {  useSelector } from "react-redux";
import LoggedInMenu from "../../../../components/LoggedInMenu/LoggedInMenu"
import {
  Container,
  MenuContainer,
  Image,
  MenuButton,
  MenuDivider,
  DrawerMenuContainer,
  LineContainer,
  MenuButtonSecondary,
  PrimaryDivider
} from "./styles/HeaderStyles";
import DrawerMenu from "../DrawerMenu/DrawerMenu"
import Notifications from "../../../../components/Notifications/Notifications";
import { useTranslation } from 'react-i18next'
import TraslateComponent from "../../../../components/TraslatePage/TraslateComponent";
import { useLocation } from "react-router-dom";

function Header() {
  const matchesWidth = useMediaQuery("(min-width:1100px)");
  const history = useHistory();
  const { authenticated } = useSelector((state) => state.authReducer);

  const [t, i18n] = useTranslation("global");

  const goToRoute = (route) => {
    history.push(route);
  };

  const location = useLocation();

  return (

    <Container>
            <PrimaryDivider/>
{/* 
      <div id="google_translate_element2"></div>

      <a onClick="doGTranslate('es|en');return false;" title="English" className="gflag nturl"
        style={{ backgroundPosition: "-0px -0px" }}><img src="//gtranslate.net/flags/blank.png" height="32" width="32"
          alt="English" />
      </a>
      <a onClick="doGTranslate('es|fr');return false;" title="French" className="gflag nturl"
        style={{ backgroundPosition: "-200px -100px" }}><img src="//gtranslate.net/flags/blank.png" height="32" width="32"
          alt="French" />
      </a>
      <a onClick="doGTranslate('es|es');return false;" title="Spanish" className="gflag nturl"
        style={{ backgroundPosition: "-600px -200px" }}><img src="//gtranslate.net/flags/blank.png" height="32" width="32"
          alt="Spanish" />
      </a> */}
      <LineContainer>
        <Image onClick={() => goToRoute("/")} src={Logo} />
        {matchesWidth ?
          <MenuContainer>
            <MenuButton active={location.pathname.includes("/app/home")}
              onClick={() => goToRoute("/app/home")} >INICIO</MenuButton>
            <MenuDivider />
            <MenuButton active={location.pathname.includes("/app/listOfServices/")} onClick={() => goToRoute("/app/allServices")}>
              {t("service")}
            </MenuButton>
            <MenuDivider />
            <MenuButton active={location.pathname.includes("/app/contact")}
              onClick={() => goToRoute("/app/contact")}>
              {t("contact")}
            </MenuButton>
            <MenuDivider />
            <MenuButton active={location.pathname.includes("/app/guide")}
              onClick={() => goToRoute("/app/guide")}>
              Guía de Inversión
            </MenuButton>
            <MenuDivider />
            <MenuDivider />
            {!authenticated ?
              <Fragment>
                <MenuButtonSecondary
                  onClick={() => goToRoute("/public/login")}>
                  {t("log-in")}
                </MenuButtonSecondary>
                <div style={{ width: "1rem" }} />
                <MenuButtonSecondary
                  onClick={() => goToRoute("/app/register")}
                >
                  Registrar
                </MenuButtonSecondary>
                <div style={{ width: '15px' }} />
                <TraslateComponent />
              </Fragment>
              :
              <Fragment>
                <MenuButton active={location.pathname.includes("/app/myDesk")}
                  onClick={() => goToRoute("/app/myDesk")}>
                  {t("desk")}
                </MenuButton>
                <MenuDivider />
                <LoggedInMenu />
                <div style={{ width: '0.5rem' }}></div>
                < Notifications color='black' />
                <MenuDivider />


                <TraslateComponent />
              </Fragment>
            }

          </MenuContainer>

          :
          <DrawerMenuContainer>
            <DrawerMenu layout="app" />
          </DrawerMenuContainer>
        }
      </LineContainer>
    </Container >
  );
}

export default Header;
